/**
 * Слой A паритета SSR/CSR (ТЗ SEO-8 §6.10): перезапись legacy-URL **до** старта
 * роутера.
 *
 * Зовётся из `main.ts` перед `bootstrapApplication`. Почему именно там, а не
 * guard'ом:
 *   * роутер стартует уже на новом URL → применяются гарды НОВОГО роута. Иначе
 *     аноним по публичной legacy-ссылке улетел бы на `/sign-in`, потому что guard
 *     переписи не успел;
 *   * нет двойной навигации и мигания 404;
 *   * крошки, `CanonicalUrlBuilder` и `SeoMetaService` с самого начала видят
 *     финальный URL.
 *
 * На SSR-деплое это **no-op**: мидлварь уже отдала 301, а `toNewPath`
 * идемпотентна. Один код на оба режима, без флагов «я CSR».
 *
 * Чистая функция над инъектированными `location`/`history` — прямой доступ к
 * `window` в этом приложении запрещён (SSR), а тестировать надо без браузера.
 */
import {resolveLegacyRedirect} from './legacy-url-map';

/** Часть `Location`, которая нужна: путь, query и якорь. */
export interface LocationLike {
  pathname: string;
  search: string;
  hash: string;
}

/** Часть `History`, которая нужна. */
export interface HistoryLike {
  replaceState(data: unknown, unused: string, url: string): void;
}

/**
 * @returns `true`, если URL был переписан (полезно для dev-предупреждения)
 */
export function rewriteLegacyLocation(loc: LocationLike, hist: HistoryLike): boolean {
  // Решение — то же, что у guard'а слоя C (`resolveLegacyRedirect`): один источник
  // правил мержа query, обработки hash и сравнения «уже новый URL». Раньше здесь
  // была вторая копия сравнения, и файл сам предупреждал, что они не должны
  // разъехаться.
  const next = resolveLegacyRedirect(`${loc.pathname}${loc.search}${loc.hash}`);
  if (next === null) {
    return false;
  }

  hist.replaceState(null, '', next);
  return true;
}
